<template>
<div class="c-recap c-home c-home--has-grid">
    <div class="c-recap__body">
        <div class="c-recap__main">
            <div class="c-recap__main-top">
                <div v-if="$mq != 'sm'" class="c-recap__links">
                    <div class="c-recap__links-top">
                        <a v-if="$root.game_info.links.postgame && $root.game_info.links.postgame.url" class="c-recap__link-button" :href="$root.game_info.links.postgame.url.replace('admin.','')" >Recap</a>
                        <a v-if="$root.game_info.links.boxscore && $root.game_info.links.boxscore.url" class="c-recap__link-button" :href="$root.game_info.links.boxscore.url">Box Score</a>
                    </div>
                    <div class="c-recap__links-bottom">
                        <a class="c-recap__link-button" :href="'https://lsusports.net/galleries/?gallery=' + gallery_id">Gallery</a>
                        <a class="c-recap__link-button" :href="column_link">Column</a>
                    </div>
                </div>
                <div class="c-recap__media-container">
                    <div class="c-recap__media">
                    <img v-if="$root.game_info.links.postgame && $root.game_info.links.postgame.story_image_url" :src="$root.game_info.links.postgame.story_image_url.replace('admin.','') + '?width=960&height=540&mode=crop&scale=both&format=jpg&quality=80'" :alt="$root.game_info.links.postgame.text" />
                    </div>
                </div>
            </div>
            <div class="c-recap__main-bottom">
                <div class="c-recap__title-links">
                    <a  v-if="$root.game_info.links.postgame && $root.game_info.links.postgame.url" class="c-recap__title" :href="$root.game_info.links.postgame.url.replace('admin.','')">{{ $root.game_info.links.postgame.text }}</a>
                    <ul v-if="$mq == 'sm'" class="c-recap__mobile-links reset-list">
                        <li class="c-recap__mobile-link">
                            <a  v-if="$root.game_info.links.postgame && $root.game_info.links.postgame.url" class="c-recap__mobile-link-url" :href="$root.game_info.links.postgame.url.replace('admin.','')">Recap</a>
                        </li>
                        <li class="c-recap__mobile-link">
                            <a  v-if="$root.game_info.links.boxscore && $root.game_info.links.boxscore.url" class="c-recap__mobile-link-url" :href="$root.game_info.links.boxscore.url">Box Score</a>
                        </li>
                        <li class="c-recap__mobile-link">
                            <a  class="c-recap__mobile-link-url" :href="'https://lsusports.net/galleries/?gallery=' + gallery_id">Gallery</a>
                        </li>
                        <li class="c-recap__mobile-link">
                            <a  class="c-recap__mobile-link-url" :href="column_link">Column</a>
                        </li>
                    </ul>
                </div>
                <div class="c-recap__hold-button">
                    <span class="c-recap__hold-button-line"></span>
                    <div class="c-recap__hold-button-inner">
                        <HoldButton :text="hold_text" v-on:max_hit="open_story"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-recap__scores">
            <div class="c-recap__team">
                <div class="c-recap__team-logo-container">
                    <div class="c-recap__team-logo">
                        <img src="@/assets/lsu_tiger.svg" alt="LSU Tigers"/>
                    </div>
                </div>
                <div v-if="$root.game_info.results && $root.game_info.results.length" class="c-recap__team-score">
                    {{ $root.game_info.results[0].team_score }}
                </div>
            </div>
            <div class="c-recap__team">
                <div class="c-recap__team-logo-container">
                    <div class="c-recap__team-logo">
                        <img src="@/assets/clemson.svg" alt="Clemson"/>
                    </div>
                </div>
                <div v-if="$root.game_info.results && $root.game_info.results.length" class="c-recap__team-score">
                    {{ $root.game_info.results[0].opponent_score }}
                </div>
            </div>
        </div>
    </div>
    <GridBackground />
    <Undefeated />
    <GlitchText :text="glitch_text"/>
</div>
</template>

<script>
import axios from 'axios'
import Slick from 'vue-slick'
import GridBackground from '@/components/GridBackground'
import GlitchText from '@/components/GlitchText.vue'
import HoldButton from '@/components/HoldButton.vue'
import Undefeated from '@/components/Undefeated.vue'

export default {
    name: 'HomeRecap',

    components: {
        GridBackground,
        GlitchText,
        HoldButton,
        Undefeated
    },

    data: () => ({
        game_content: {},
        gallery_content:{},
        gallery_id: 1098,
        column_link: 'https://lsusports.net/news/2020/1/14/football-for-lsu-its-a-perfect-ending-and-a-perfect-beginning-too.aspx',
        slick_options: {
            slidesToShow: 1,
            slidesToScroll:1
        },
        glitch_text: 'THE GAME. THE RECAP.',
        hold_text: 'Hold for Story'
    }),

    methods: {
        get_data() {
            if(!this.$root.got_game){
                let gamePromise =  new Promise((resolve) => {
                    axios.get('/services/schedule_xml_2.aspx?format=json&path=fb&starting=1/10/2020&ending1/15/2020&take=1')
                    .then(response => {

                            let result = response.data.schedule[0];
                            if(result.links.postgame){
                                this.$root.game_info.links.postgame = result.links.postgame;
                            }
                            if(result.links.boxscore){
                                this.$root.game_info.links.boxscore = result.links.boxscore;
                            }
                            if(result.results && result.results.length){
                                this.$root.game_info.results = result.results;
                            }

                            this.$root.got_game = true;
                        resolve();
                    });
                });
            }
        },
        open_story(){
            window.location.href = this.$root.game_info.links.postgame.url ? this.$root.game_info.links.postgame.url.replace('admin.','') : '#';
        }

    },

    created() {
        this.get_data();
    },

    watch: {
        game_content: function () {

        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../styles/imports";
    .c-recap{
        &__body{
            @include flex-container;
            @include flex-column;
            position:relative;
            z-index:5;
        }
        &__main{
            @include flex-item(0 0 auto);
            @include order(1);
        }
        &__main-top{
            width:100%;
            padding:0 24px;
            @include flex-container;
        }
        &__links{
            @include flex-item(0 1 auto);
            width:33.3333%;
        }
        &__links-top, &__links-bottom{
            
            padding:12px 24px 0 24px;
            @include flex-container;
            @include flex-column;
            @include align-start;
            @include justify-center;
        }
        &__links-bottom{
            padding-top:0;
        }
        &__link-button{
            display:block;
            text-decoration:none;
            text-transform:uppercase;
            color:$white;
            line-height:1.1;
            font-size:1.125rem;
            position:relative;
            z-index:2;
            letter-spacing: 0.3rem;
            border:solid 1px $gold;
            font-weight:300;
            padding:10px 12px; 
            margin:10px 0; 
            white-space:nowrap;
            transition:0.2s;
            &:hover{
                background:$gold;
                color:$purple;
            }
        }
        
        &__media-container{
            @include flex-item(0 0 auto);
            width:100%;
        }
        &__media{
            width:100%;
            height:0;
            padding-bottom:56.25%;
            position:relative;
            overflow:hidden;
            img{
                position:absolute;
                top:0;
                left:0;
                width:100%;
            }
        }
        &__main-bottom{
            @include flex-container;
            @include align-start;
            @include justify-start;
            
            position:relative;
        }
        &__title{
            padding:24px 24px 18px;
            display:block;
            font-size:1.125rem;
            letter-spacing:0.225rem;
            color:$white;
            text-transform:uppercase;
            position:relative;
            line-height:1.6;
            text-decoration:none;
            &::after{
                position:absolute;
                bottom:0;
                left:0;
                width:100px;
                height:6px;
                content:'';
                background:$gold;
                transition:0.4s;
            }
            &:hover{
                &::after{
                    width:100%;
                }
            }
        }
        &__mobile-links{
            @include flex-container;
            @include flex-wrap;
            padding-left:12px;
            padding-top:24px;
        }
        &__mobile-link{
            margin-bottom:12px;
            line-height:1.2;
            white-space:nowrap;
            padding:0 12px;
            color:$white;
            text-transform:uppercase;
            font-weight:300;
            font-size:1rem;
            letter-spacing:0.2rem;
            position:relative;
            &::after{
                position:absolute;
                top:50%;
                right:0;
                content:'|';
                @include transform(translateY(-50%));
            }
            &:last-child{
                padding-right:0;
                &::after{
                    display: none;
                }
            }
        }
        &__mobile-link-url{
            text-decoration:none;
            color:$white;
            text-transform:uppercase;
            font-weight:300;
            font-size:1rem;
            letter-spacing:0.2rem;
        }
        &__hold-button{
            padding-right:24px;
            text-align:center;
            @include flex-container;
            @include flex-column;
            @include align-center;
            @include justify-center;
        }
        &__hold-button-line{
            display:block;
            @include flex-item(1 1 auto);
            width:1px;
            height:24px;
            background:$white;
            
        }
        &__hold-button-inner{
            @include flex-item(0 0 auto);
        }
        &__scores{
            @include flex-item(0 0 auto);
            @include order(0);
            @include flex-container;
            padding-bottom:24px;
        }
        &__team{
            @include flex-container;
            @include justify-center;
            @include flex-item(0 0 auto);
            width:50%;
        }
        &__team-logo-container{
            @include flex-item(0 0 auto);
            width:48px;
            margin:0 12px;
        }
       
        &__team-score{
            @include flex-container;
            @include flex-item(0 0 auto);
            @include align-center;
            @include justify-center;
            color:$white;
            font-size:2rem;
            font-weight:700;
            margin:0 12px;
        }

        @media all and (min-width:$small-breakpoint){
            .c-recap{
                &__body{
                    @include flex-row;
                }
                &__main{
                    width:60%;
                    @include order(0);
                }
                &__main-top{
                    padding:0;
                }
                &__media-container{
                    width:66.6667%;
                }
                &__main-bottom{
                    min-height:calc(100vw * 0.6 * 0.33333 * 0.5625);
                    padding:0 24px;
                     @include align-center;
                }
                &__title{
                    font-size:1.85rem;
                    letter-spacing:0.25rem;
                    line-height:1.2;
                    padding:36px 0;
                }
                &__hold-button{
                    position:absolute;
                    top:0;
                    right:0;
                    width:calc(20vw * .75);
                    height:100%;
                    padding-right:0;
                    border-left:solid 1px $white;
                    @include transform(translateX(100%));
                    @include flex-row;
                    @include justify-start;
                    @include align-center;
                }
                &__hold-button-line{
                    width:100%;
                    display:inline-block;
                    border-bottom:solid 1px $white;
                    height:1px;
                    background:none;
                }
                &__scores{
                    @include flex-item(0 1 auto);
                    width:40%;
                    @include order(1);
                    display:block;
                    padding-bottom:0;
                }
                &__team{
                    width:100%;
                }
                &__team-logo-container{
                    width:50%;
                    margin:0;
                }
                &__team-logo{
                    width:100%;
                    padding-bottom:56.25%;
                    position:relative;
                    img{
                        position:absolute;
                        top:50%;
                        left:50%;
                        height:calc(100% - 48px);
                        max-height:120px;
                        @include transform(translate(-50%,-50%));
                    }
                }
                &__team-score{
                    font-size:4.5rem;
                    width:50%;
                    margin:0;
                }
            }
        }

        @media all and (min-width:$medium-breakpoint){
            .c-recap{
                &__links-top, &__links-bottom{
                     padding:12px 24px 0 48px;
                }
                &__main-bottom{
                    padding:0 48px;
                }
            }
        }

        @media all and (min-width:$x-large-breakpoint){
            .c-recap{
                &__team-score{
                    font-size:7.5rem;
                }
                &__links-top, &__links-bottom{
                    min-height:calc(100vw * 0.6 * 0.33333 * 0.5625);
                    padding:12px 24px 0 96px;
                }
                &__link-button{
                    font-size:1.5rem;
                    padding:20px 24px; 
                }
                &__title{
                    font-size:2.25rem;
                    letter-spacing:0.45rem;
                }
                &__main-bottom{
                    padding:0 96px;
                }
            }

        }

    }

</style>